import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  modalSubmit(event) {
    event.preventDefault();
  
    const modal = event.currentTarget.closest(".modal");
    const form = this.element;

    form.addEventListener("turbo:submit-end", () => {
      if (modal) {
        $(modal).modal("hide");
      }
    }, { once: true }); // Ensure it runs only once

    form.requestSubmit();
  }
}
